import type { StructuredMethodology } from './methodologyContentProps';

export function buildCarbonIntensityVerifiedMethodology(): StructuredMethodology {
  return {
    primarySources: [
      'California Energy Commission Power Source Disclosure / Power Content Labels for matched load-serving entities where available.',
      'U.S. EPA eGRID utility/subregion emissions factors where used as fallback.',
    ],
    calculation: [
      'Match the selected jurisdiction to its electricity provider / community choice aggregator.',
      'Use provider-specific Power Content Label intensity where available under the current hierarchy.',
      'Otherwise use the documented eGRID value for the matched utility/subregion.',
      'When multiple LSE products are combined, use the implemented load-weighting method.',
      'Fill internal time-series gaps only according to the interpolation/extrapolation rules in the carbon-intensity service.',
    ],
    limitations: [
      'Provider procurement intensity and regional/grid-average intensity are different concepts.',
      'Interpolated or extrapolated values are estimates.',
      'Provider or source transitions may create methodological breaks in the time series.',
    ],
    technicalDetails: [
      'egrid_utilities',
      'lse_carbon_intensity',
      'CCAS provider matching',
      'carbonIntensityService.ts',
      'CarbonIntensityChart.tsx',
    ],
  };
}
